import React from 'react'
import { injectIntl } from 'react-intl'
import { defaultMessages } from '../../../../libs/i18n/default'
import  ReactMarkdown from 'react-markdown';

class FormHeader extends React.Component {
  render(){
    const { formatMessage }  = this.props.intl

    return (
      <div className='form-header'>
         <div className='header-icon header-icon-left'>
           <h1>
              {this.props.icon}
           </h1>
         </div>


         <ReactMarkdown source={this.props.title} className='form-header-center'/>

         <div className='header-icon header-icon-right'>
           <h1>
              {this.props.icon}
           </h1>
         </div>
      </div>
    );
  }

};

export default injectIntl(FormHeader)